import React from 'react';
import Anchor from '../../objects/Anchor'

const DocumentsCard = props => {

    const { title, url } = props.documentsData;
    const clever = props.clever === true ? 'clever' : '';
    let card;

    switch(props.length)
    {
        case 1: card = ''
        break;
        case 2: card = 'col-sm-6'
        break;
        case 3: card = 'col-xl-4'
        break;
        default: card = 'col-sm-6 col-xl-3'
    }

    return (
        <div className={`col-12 ${card} base-card documents-card ${clever}`}>
            <Anchor path={url} anchorClass="card-inner" target>
                <div className="theme-documents-head">
                    <div className="hexagon-no-bg">
                        <img src="/images/icons-new/download-white.svg" alt="documents icon"
                             className="documents-image"/>
                    </div>
                </div>
                <div className="theme-documents-body">
                    <h3 className="heading-three">{title}</h3>
                    <div className="body-foot">
                        <img src="/images/icons-new/download-grey.svg" alt="clock icon"
                             className="foot-img"/>
                        <p className="body-copy">Download</p>
                    </div>
                    <span className="theme-button">Download</span>
                </div>
            </Anchor>
        </div>
    );
};

export default DocumentsCard;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/cards/DocumentsCard.js